import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { BookOpenIcon, ClipboardCheckIcon, CalendarIcon, MessageCircleIcon } from 'lucide-react';
export function OfferSection() {
  const deliverables = [{
    icon: <BookOpenIcon className="w-8 h-8" data-id="element-196" />,
    title: 'El Manual Maestro',
    desc: 'Los 7 Síntomas Silenciosos del Vacío Emocional Femenino.'
  }, {
    icon: <ClipboardCheckIcon className="w-8 h-8" data-id="element-197" />,
    title: 'Test de Autodiagnóstico',
    desc: 'Para saber cuál de los 7 silencios es el que está matando tu relación hoy.'
  }, {
    icon: <CalendarIcon className="w-8 h-8" data-id="element-198" />,
    title: 'El Plan de 7 Días',
    desc: 'Acciones diarias de 10 minutos para romper la rutina emocional sin esfuerzo.'
  }, {
    icon: <MessageCircleIcon className="w-8 h-8" data-id="element-199" />,
    title: 'Plantillas de Diálogo',
    desc: 'Qué decir exactamente para reabrir el corazón de tu hombre sin sonar a reclamo.'
  }];
  return <section id="offer" className="py-24 px-4 md:px-8 bg-cream-dark relative" data-id="element-200">
      {/* Dot Grid Background */}
      <div className="absolute inset-0 dot-grid opacity-50 pointer-events-none" data-id="element-201"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-202">
        <FadeIn className="text-center mb-16" data-id="element-203">
          <h2 className="text-3xl md:text-5xl font-serif text-burgundy-dark mb-6" data-id="element-204">
            Al descargar la guía hoy, obtendrás:
          </h2>
          <div className="w-24 h-[2px] bg-gold mx-auto rounded-full" data-id="element-205"></div>
        </FadeIn>

        {/* Ebook Cover */}
        <FadeIn className="flex justify-center mb-16" data-id="element-206">
          <div className="relative" data-id="element-207">
            <div className="absolute -inset-4 bg-gradient-to-br from-gold/20 to-rose/20 rounded-3xl blur-2xl" data-id="element-208"></div>
            <img src="https://cdn.magicpatterns.com/uploads/diq7zAUvEWWs5qmFtj8syT/heylloyd-image-1773698007028.png" alt="Portada del ebook: Los 7 Síntomas Silenciosos del Vacío Emocional Femenino" className="relative w-64 md:w-80 rounded-2xl shadow-2xl border-2 border-white/50" data-id="element-209" />
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10" data-id="element-210">
          {deliverables.map((item, idx) => <FadeIn key={idx} delay={idx * 0.15} className="h-full perspective-1000" data-id="element-211">
              <motion.div whileHover={{
            y: -10,
            rotateX: 2,
            rotateY: -2,
            boxShadow: '0 25px 50px -12px rgba(123, 45, 59, 0.15)'
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 20
          }} className="group h-full flex flex-col items-center text-center p-10 bg-white rounded-[2rem] shadow-lg border border-transparent hover:border-gold/30 transition-colors duration-500 relative overflow-hidden" data-id="element-212">
                {/* Subtle gradient hover background */}
                <div className="absolute inset-0 bg-gradient-to-br from-rose-light/0 to-gold/0 group-hover:from-rose-light/20 group-hover:to-gold/10 transition-all duration-500" data-id="element-213"></div>

                <motion.div initial={{
              scale: 0,
              rotate: -15
            }} whileInView={{
              scale: 1,
              rotate: 0
            }} viewport={{
              once: true
            }} transition={{
              type: 'spring',
              delay: 0.3 + idx * 0.1,
              bounce: 0.5
            }} className="w-20 h-20 rounded-2xl bg-cream flex items-center justify-center text-gold-dark mb-8 group-hover:bg-gold group-hover:text-white transition-colors duration-500 relative z-10 shadow-inner" data-id="element-214">
                  {item.icon}
                </motion.div>

                <h3 className="text-2xl font-serif font-bold text-burgundy-dark mb-4 relative z-10" data-id="element-215">
                  {item.title}
                </h3>
                <p className="text-charcoal-light leading-relaxed text-lg relative z-10" data-id="element-216">
                  {item.desc}
                </p>
              </motion.div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}